import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import VisitService from "../../services/VisitService";

function BodyAcupunctureVisits() {
  const { patientID } = useParams();
  const navigate = useNavigate();
  const [visits, setVisits] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadVisits = async () => {
      try {
        const data = await VisitService.getAllVisitsByPatientId(patientID);

        if (!Array.isArray(data)) {
          setVisits([]);
          return;
        }

        const filteredVisits = data
          .map(visit => {
            const items = (visit.visitItemDTOS || [])
              .filter(item => item.treatmentTypeDTO?.typeName === "BodyAcupuncture");
            return items.length > 0 ? { ...visit, visitItemDTOS: items } : null;
          })
          .filter(Boolean)
          .sort((a, b) => new Date(a.visitDate) - new Date(b.visitDate));

        setVisits(filteredVisits);
      } catch (error) {
        console.error("Greška:", error);
        setVisits([]);
      } finally {
        setLoading(false);
      }
    };
    loadVisits();
  }, [patientID]);

  if (loading) return <p>Učitavanje poseta...</p>;

  const formatDate = (dateString) => new Date(dateString).toLocaleDateString("sr-RS");

  const patientName = visits[0]?.patientDTO
    ? `${visits[0].patientDTO.name} ${visits[0].patientDTO.surname}`
    : "";

  return (
    <div style={{ padding: "30px", textAlign: "center" }}>
      <h2 style={{ marginBottom: "25px", color: "#333" }}>
        Body Acupuncture — posete pacijenta: {patientName}
      </h2>

      {visits.length === 0 ? (
        <p style={{ fontStyle: "italic" }}>
          Nema evidentiranih Body Acupuncture tretmana.
        </p>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table style={{
            width: "100%",
            borderCollapse: "collapse",
            borderRadius: "10px",
            overflow: "hidden",
            boxShadow: "0 0 10px rgba(0,0,0,0.1)"
          }}>
            <thead style={{ backgroundColor: "#007bff", color: "white" }}>
              <tr>
                <th style={thStyle}>Datum</th>
                <th style={thStyle}>Akupunkturne tačke</th>
                <th style={thStyle}>Napomena</th>
              </tr>
            </thead>
            <tbody>
              {visits.map((visit) =>
                visit.visitItemDTOS.map((item, iIndex) => (
                  <tr key={`${visit.visitID}-${iIndex}`} style={rowStyle}>
                    <td style={tdStyle}>{formatDate(visit.visitDate)}</td>
                    <td style={tdStyle}>{item.treatmentTypeDTO?.acupuncturePoints ?? "-"}</td>
                    <td style={{
                      ...tdStyle,
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                      textAlign: "left"
                    }}>
                      {item.notes && item.notes.trim() !== ""
                        ? item.notes
                        : visit.notes && visit.notes.trim() !== ""
                        ? visit.notes
                        : "-"}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

      <button onClick={() => navigate(-1)} style={backButton}>
        Nazad
      </button>
    </div>
  );
}

const thStyle = { padding: "10px 15px", borderBottom: "2px solid #0056b3" };
const tdStyle = { padding: "10px 15px", borderBottom: "1px solid #ddd" };
const rowStyle = { backgroundColor: "white", transition: "0.2s", textAlign: "center" };
const backButton = { marginTop: "25px", padding: "10px 25px", borderRadius: "6px", border: "none", backgroundColor: "#007bff", color: "white", fontWeight: "bold", cursor: "pointer" };

export default BodyAcupunctureVisits;
